import { FailureResponse } from './types';

export const isFailureResponse = (response: unknown): response is FailureResponse => {
  return (response as FailureResponse)?.error !== undefined;
};
